// From: https://reactjs.org/docs/higher-order-components.html
export default (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component'
